export const generateTimesheetKey = (timesheet) => {
  const {
    user, start_date,
  } = timesheet;

  // because the timesheet is a synthesized object, the key is composite.
  // TODO consider server to include the composite key as an id field.
  // need to think through the API to determine if this a unique key
  // or just unique for this speicfic use case
  const timesheetKey = `${user.id},${start_date.iso8601}`;
  return timesheetKey;
};

export const parseTimesheetKeyforUserId = (timesheetKey) => {
  let userId = null;
  if (timesheetKey) {
    const keys = timesheetKey.split(',');
    if (keys.length === 2) {
      userId = parseInt(keys[0], 10);
    }
  }
  return userId;
};

export const parseTimesheetKeyforDate = (timesheetKey) => {
  if (timesheetKey) {
    const keys = timesheetKey.split(',');
    if (keys.length === 2) {
      const [, date] = keys;
      return date;
    }
  }
  return null;
};
